import {
  CLEAR_DELETED_VARIABLES,
  CLEAR_NEW_VARIABLE,
  DELETED_VARIABLES_CLEARED,
  EDIT_VARIABLE,
  EDIT_VARIABLES,
  EDIT_INSTANCE,
  INIT_NEW_VARIABLE,
  STOP_EDITING,
  STOP_EDITING_VARIABLES
} from '../actions/types'

const variablesReducer = function (state = {
  clearDeletedVariables: false,
  creating: false,
  editing: false,
  editMode: true,
  instance: null
}, action) {
  switch (action.type) {
    case EDIT_VARIABLE:
      return {
        ...state,
        editing: action.varName
      }
    case EDIT_VARIABLES:
      return {
        ...state,
        editMode: true
      }
    case EDIT_INSTANCE:
      return {
        ...state,
        instance: action.key
      }
    case STOP_EDITING_VARIABLES:
      return {
        ...state,
        editMode: false
      }
    case INIT_NEW_VARIABLE:
      return {
        ...state,
        creating: true
      }
    case CLEAR_NEW_VARIABLE:
      return {
        ...state,
        creating: false
      }
    case DELETED_VARIABLES_CLEARED:
      return {
        ...state,
        clearDeletedVariables: false
      }
    case CLEAR_DELETED_VARIABLES:
      return {
        ...state,
        clearDeletedVariables: true
      }
    case STOP_EDITING:
      return {
        ...state,
        editing: false
      }
    default:
      return state
  }
}
export default variablesReducer



// WEBPACK FOOTER //
// /app/js/reducers/variablesReducer.js